<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 网络配置 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.network1") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 网卡名称-->

                                <td>{{ $t("logs.network1_a6") }}:</td>
                                <td>
                                    <el-select v-model="network" placeholder class="selece1" @change="edit_show_network">
                                        <el-option v-for="item in network_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr>
                                <!-- ip地址 -->

                                <td>{{ $t("logs.network1_a5") }}:</td>
                                <td style="display:flex;flex-direction: row;"> 
                                    <div><el-input v-model="ipaddr" placeholder></el-input></div>
                                  
                                   
                                </td>
                            </tr>
                           
                            <tr>
                                <!-- 子网掩码 -->

                                <td>{{ $t("logs.network1_a1") }}:</td>
                                 <td style="display:flex;flex-direction: row;"> 
                                    <div><el-input v-model="netmask" placeholder ></el-input></div>
                                   
                                   
                                </td>
                             
                            </tr>
                            <tr>
                                <!-- 网关地址 -->

                                <td>{{ $t("logs.network1_a2") }}:</td>
  <td style="display:flex;flex-direction: row;"> 
                                    <div> <el-input v-model="gateway" placeholder></el-input></div>
                                   
                                   
                                </td>
                               
                            </tr>
                             <tr v-if="this.ipaddr_v6_show==1">
                                <!-- 启用ipv6 -->
                                <td>{{ $t("logs.network1_aa_v6") }}:</td>
                                <td>
                                    <el-checkbox-group v-model="enable_ipv6">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                </td>
                            </tr>
                             <tr  v-if="this.ipaddr_v6_show==1">
                                <!-- ip地址 -->

                                <td>{{ $t("logs.network1_a5_v6") }}:</td>
                                <td style="display:flex;flex-direction: row;"> 
                                   
                                    <div > <el-input v-model="ipaddr_v6" placeholder></el-input></div>
                                   
                                </td>
                            </tr>
                           
                           
                            <tr  v-if="this.ipaddr_v6_show==1">
                                <!-- 网关地址 -->

                                <td>{{ $t("logs.network1_a2_v6") }}:</td>
  <td style="display:flex;flex-direction: row;"> 
                                    
                                    <div > <el-input v-model="gateway_v6" placeholder></el-input></div>
                                   
                                </td>
                               
                            </tr>
                            <tr>
                                <!-- dns1 -->

                                <td>DNS1:</td>
                                <td>
                                    <el-input v-model="dns1" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>DNS2:</td>
                                <td>
                                    <el-input v-model="dns2" placeholder></el-input>
                                </td>
                            </tr>
 
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_setting()" :disabled="$root.jurisdiction.only_query==0" >{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- 网络代理 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.network2") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 启用 -->
                                <td>{{ $t("logs.base8_a1") }}:</td>
                                <td>
                                    <el-checkbox-group v-model="enable_proxy">
                                        <el-checkbox label></el-checkbox>
                                    </el-checkbox-group>
                                </td>
                            </tr>
                            <tr>
                                <!-- 代理地址 -->

                                <td>{{ $t("logs.network2_a1") }}:</td>
                                <td>
                                    <el-input v-model="proxy_server" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("logs.network2_a2") }}:</td>
                                <td>
                                    <el-input v-model="proxy_port" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("logs.network2_a3") }}:</td>
                                <td>
                                    <el-input v-model="proxy_user" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("logs.network2_a4") }}:</td>
                                <td>
                                    <el-input v-model="proxy_password" placeholder show-password></el-input>
                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_proxy()"  :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- 网络测试 -->
            <el-tab-pane>
                <span slot="label">
                    {{ $t("logs.network3") }}
                </span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 测试程序 -->

                                <td>{{ $t("logs.network3_a1") }}:</td>
                                <td>
                                    <el-select v-model="program_type" placeholder class="selece1" @change="program_type_style">
                                        <el-option v-for="item in program_type_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr v-if="this.traceroute_type==1">
                                <!-- 解析类型 -->
                                <td>{{ $t("logs.network3_a3") }}:</td>
                                <td>
                                    <el-select v-model="digtype" placeholder class="selece1">
                                        <el-option v-for="item in digtype_arr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr>
                                <!-- 主机名或IP地址 -->
                                <td>{{ $t("logs.network3_a2") }}:</td>
                                <td>
                                    <el-input v-model="test_host" placeholder></el-input>
                                </td>
                            </tr>
                            <tr v-if="this.telnet_type==1">
                                <!-- 端口查询 -->
                                <td>{{ $t("logs.network3_a6") }}:</td>
                                <td>
                                    <el-input v-model="telnetport" placeholder></el-input>
                                </td>
                            </tr>
                            <tr v-if="this.ping_type==1">
                                <!-- 测试条数 -->
                                <td>{{ $t("logs.network3_a7") }}:</td>
                                <td>
                                    <el-input v-model="ping_num" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_test()"  :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.network3_a5") }}</el-button>

                                </td>
                            </tr>

                        </tbody>
                        <tbody>
                            <tr>
                                <td>{{ $t("logs.network3_a4") }}:</td>
                                <td style="width:65%">
                                    <el-input type="textarea" :autosize="{ minRows: 10,maxRows: 16 }" placeholder="" v-model="textarea_res" readonly>
                                    </el-input>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            ipaddr_v6_show:'',
            ipaddr_v6:'',
            telnetport: '25',
            ping_num: '4',
            data_loadok_setting: '',
            data_loadok_proxy: '',
            data_loadok_test: '',
            network: '',
            
            network_arr: [],
            textarea_res: '',
            digtype: 'mx',
            digtype_arr: [],
            test_host: '',
            program_type: 'dig',
            program_type_arr: [],
            proxy_password: '',
            proxy_user: '',
            proxy_port: '',
            proxy_server: '',
            enable_proxy: false,
            dns2: '',
            dns1: '',
            gateway: '',
            gateway_v6: '',
            netmask: "",
            netmask_v6: "",
            ipaddr: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS"
                },
                {
                    value: "选项2",
                    label: "增加信头标记"
                },
                {
                    value: "选项3",
                    label: "强制TLS"
                }
            ],
            checked: "",
            fileList: [],
            radio: [],
            telnet_type: 0,
            ping_type: 0,
            traceroute_type: 1,
            enable_ipv6:false,
        };
    },
    mounted() {
        this.getFileList1()
        this.getFileList2()
        this.getFileList3()

    },
    methods: {
          edit_show_network(val) {
            // console.log(a);
           
            this.network=val
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_network",
                        sid: sid,
                       
                        netname:  this.network,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");

                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.ipaddr = res.data.ret.result.IPADDR

                        this.network = res.data.ret.result.NETNAME
                        this.netmask = res.data.ret.result.NETMASK
                        this.dns1 = res.data.ret.result.DNS1
                        this.dns2 = res.data.ret.result.DNS2
                        // this.network_arr = res.data.ret.q_nets
                        this.data_loadok_setting = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        this.gateway = res.data.ret.result.GATEWAY
                    }
                });
        },
        program_type_style(a) {
            // console.log(a)
            if (a == 'telnet') {
                this.telnet_type = 1
                this.traceroute_type = 0
                this.ping_type = 0

            } else if (a == 'ping') {
                this.ping_type = 1
                this.telnet_type = 0

            } else if (a == 'traceroute') {
                this.traceroute_type = 0
                this.ping_type = 0
                this.telnet_type = 0

            } else {
                this.telnet_type = 0
                this.ping_type = 0
                this.traceroute_type = 1

            }
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 网络配置加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_network",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        // this.byad = res.data.ret.result.USE_AD_AUTH == 0 ? this.bypop = false : true

                        this.ipaddr = res.data.ret.result.IPADDR
                        this.ipaddr_v6 = res.data.ret.result.IPADDR_V6

                        this.network = res.data.ret.result.NETNAME
                        this.netmask = res.data.ret.result.NETMASK
                        this.dns1 = res.data.ret.result.DNS1
                        this.dns2 = res.data.ret.result.DNS2
                        this.network_arr = res.data.ret.q_nets
                        this.data_loadok_setting = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        this.gateway = res.data.ret.result.GATEWAY
                        this.gateway_v6 = res.data.ret.result.GATEWAY_V6
                        this.ipaddr_v6_show=res.data.ret.SYS_NETWORK_CAN_SET_IPV6
                        // 

                    }
                })
               
        },
        // 网络配置保存
        tanSend_setting() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_network",
                sid: sid,
                // byad: this.byad == true ? 1 : 0,

                dns2: this.dns2,
                network: this.network,
                dns1: this.dns1,
                gateway: this.gateway,
                ipv6gateway: this.gateway_v6,
                netmask: this.netmask,
                ipaddr: this.ipaddr,
                ipv6addr: this.ipaddr_v6,

                data_loadok: this.data_loadok_setting

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
        // 网络代理加载
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "cfg_network",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.enable_proxy = res.data.ret.ACTIVE == 0 ? this.enable_proxy = false : true

                        this.proxy_server = res.data.ret.PROXY_SERVER

                        this.proxy_port = res.data.ret.PROXY_PORT
                        this.proxy_user = res.data.ret.PROXY_USER
                        this.proxy_password = res.data.ret.PROXY_PASSWORD

                        // this.data_loadok_proxy = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
               
        },
        // 网络代理保存
        tanSend_proxy() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_netproxy",
                sid: sid,
                enable_proxy: this.enable_proxy == true ? 1 : 0,

                proxy_server: this.proxy_server,

                proxy_port: this.proxy_port,
                proxy_user: this.proxy_user,
                proxy_password: this.proxy_password,

                // data_loadok: this.data_loadok_proxy

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList2();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
        // 网络测试加载
        getFileList3() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_test_net",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        // this.enable_proxy = res.data.ret.result.USE_AD_AUTH == 0 ? this.enable_proxy = false : true

                        this.program_type_arr = res.data.ret.q_program_type

                        this.digtype_arr = res.data.ret.q_digtype
                        // this.test_host = res.data.ret.result.LD_BASE

                        // this.data_loadok_test = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
               
        },
        // 网络测试保存
        tanSend_test() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "test_network",
                sid: sid,
                // enable_proxy: this.enable_proxy == true ? 1 : 0,

                digtype: this.digtype,

                test_host: this.test_host,
                program_type: this.program_type,
                telnetport: this.telnetport,
                ping_num: this.ping_num,

                data_loadok: this.data_loadok_test

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.textarea_res = res.data.ret.RUN_RESULT
                       

                    }
                })
               

        },
    }
};
</script>

<style lang="less" scoped>
// input 框高度
/deep/ .el-input__i nner {
    height: 30px;
}

/deep/ .el-alert__content {
    padding: 0;
}

/deep/ .el-input--suffix {
    width: 280px;
}

//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

// 1

.main p {
    padding-left: 10px;
    font-size: 14px;
    line-height: 28px;
}

// .main span {
//     padding-left: 20px;
// }

.el-button {
    padding: 6px;
}

.find2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //   height: 300px;
    padding-top: 30px;
    padding-left: 30px;
    width: 50%;
    margin-bottom: 20px;
}

.find2-1 {
    width: 100%;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    //   justify-content: center;

    div {
        padding: 0 5px;
    }
}

.find2-1 .find-text {
    font-size: 14px;
}

.find2-1 .el-row {
    margin-left: 140px;
}

// input 框高度
/deep/ .el-input__inner {
    height: 26px;
}

// 弹出框1
// 一行
.find {
    display: flex;
    //   flex: 1;
    overflow: auto;
    flex-direction: column;
    text-align: left;
    background: #f1f1f1;
    border: 1px solid #dcdfe6;
    margin-top: 10px;
    padding: 40px 0;
    width: 80%;

    p {
        color: #999;
        font-size: 12px;
        text-align: center;
    }
}

.find1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2px 0;
}

// 文字
.find-text {
    padding: 0 20px;
    font-size: 12px;
}

.el-input {
    // width: 20%;
    padding: 5px 10px 5px 0;
}

/deep/ .el-select {
    // padding-left: 30px;
    width: 222px;
}

// button  按钮
/deep/ .el-button {
    padding: 5px 10px;
    margin-left: 10px;
    font-size: 12px;
    background: #eceff4;
}

.pop-up {
    position: fixed;
    padding: 20px 0;
    width: 50%;
    //   height: 80%;
    top: 10%;
    left: 25%;
    z-index: 101;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    //   margin-left: -12.5%;
    //   margin-top: -14%;
}

.gray {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: black;
    opacity: 0.6;
    z-index: 100;
}

// input 框高度
/deep/ .el-input__inner {
    height: 30px;
}

.el-checkbox-group {
    display: flex;
}

.table span {
    font-size: 14px;
}

// th  改高度
/deep/ .el-table th {
    padding: 4px 0;
}

// td  改高度
/deep/ .el-table td {
    padding: 4px 0;
}

/deep/ .cell {
    text-align: center;
}

// 时间
.time {
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
    background: #f1f1f1;
    margin: 10px 0;
}

.time1 {
    display: flex;
    align-items: center;
    padding: 2px 0 2px 14px;
    font-size: 14px;
}

// 手动设置
.time-text1 {
    padding-left: 20px;
}

// 后台管理控制
.back {
    display: flex;
    font-size: 14px;
    line-height: 30px;
    align-items: center;
    padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
    margin: 0 10px;
}

.backText {
    text-align: right;
}

.backText1 {
    color: #999;
    font-size: 12px;
}

.back .el-input {
    width: 20%;
    padding: 0;
}

.time2 {
    display: flex;
    margin-left: 190px;
    margin-top: 10px;
}

.time2 .el-button {
    padding: 8px 24px;
    // margin: 10px ;
}

// License
.time3 {
    display: flex;
    align-items: center;
    // margin-left: 150px;
    font-size: 14px;
    padding: 4px 10px;
}

// selece
.selece1 {
    width: 130px;
}

// input 框
.back1 .input1 {
    width: 100px;
    margin: 0 10px;
}

// 单选框
.check1 {
    margin: 0 10px;
}

.backText2 {
    margin-left: 40px;
}

.backText3 {
    margin-left: 30px;
}

.back1 .input5-1 {
    width: 100px;
}

/deep/.el-input__icon {
    line-height: 30px;
    height: 30px;
}

// background: #424F63;
/deep/ .el-tabs__item .is-top {
    font-size: 12px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
    border-left: 0px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
    padding-right: 20px;
}

// /deep/ .el-tabs__item.is-active {
//     //   color: #409eff;
//     background: #fff;
// }

// /deep/ .el-tabs__active-bar {
//     height: 0;
// }

// 弹框下的复选框
.el-checkbox:last-of-type {
    margin-right: 10px;
}

@import "../../css/table.less";

@import "../../css/lie_td.less";
</style>
